module.exports = __webpack_public_path__ + "assets/9015a9270e5f377672ed27265e127d18.png";